export class greetingImage{
  url:string = '';
}

export class GreetingDetails {
  greetingTitle:string = '';
  greetingText:string = '';
  greetingImage:greetingImage = new greetingImage()
}

export class GreetingModel {
  flatData: GreetingDetails = new GreetingDetails();
}